/*
 * @Descripttion: 人群批量选择
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React, { useState, useEffect, useContext } from 'react';
import { Button, Form } from '@alifd/next';
import { store } from '@ice/stark-data';
import moment from 'moment';
import styles from '../../../index.module.scss';
import LzMsg from '@/components/common/LzMsg';
import { CanvasService } from '@/service';
import SelectCrowdBatch from '@/components/SelectCrowdBatch';
import crowdPng from '@/assets/images/CanvasImages/crowd.png';
import deletePng from '@/assets/images/CanvasImages/close.png';
import UUID from '@/utils/UUID';
import { ActivityContext, PageType } from '../../../../Edit';
import CrowdNumDialog from '../../../components/CrowdNumDialog';
import nodes from '../../index';

export default ({
  allNodeData = [],
  activityInfo = {},
  initData = {},
  runState = {},
  currentNode = {},
  changeData = (data) => { },
  onCancel = () => { },
  validate = () => { },
  getAllNodeIds = [],
}) => {
  // 判断人群节点是否超出150的限制，提示弹窗flag
  const [crowdNodeNumDialog, setCrowdNodeNumDialog] = useState(false);
  // 控制选择人群弹窗变量
  const [isSelectCrow, setSelectCrow] = useState(false);
  // 组件内部的数据
  const [data, setData] = useState({});
  const [checkedCrowdArr, setCheckedCrowdArr] = useState([]); // 批量选择的人群数组
  const {
    graph,
    powerInfo,
    nodeData,
    getAllNodes,
    canvasInfo,
    strategyNodeNums,
  } = useContext(ActivityContext);

  /**
   * 选择人群包
   */
  const selectCrowsId = (item) => {
    const tempArr = JSON.parse(JSON.stringify(item));
    tempArr.forEach((item) => {
      if (item.crowdType !== 'instance') {
        // 除了人群包，人群策略、重点人群需要预计算人数
        CanvasService.preCalcPeopleCount({ strategyId: item.strategyId })
          .then((res) => {
            item.total = res.data; // 用预计算的人群总数覆盖total字段原始值
          })
          .catch((e) => {
            console.log(e);
          });
      }
    });
    setCheckedCrowdArr(tempArr);
  };

  /**
   * 根据id删除所选人群
   */
  const deleteCrowd = (id) => {
    const ids = [];
    checkedCrowdArr.forEach((item) => {
      ids.push(item.id);
    });
    const deleteIndex = ids.findIndex((item) => item === id);
    checkedCrowdArr.splice(deleteIndex, 1);
    const tempCheckedCrowdArr = JSON.parse(JSON.stringify(checkedCrowdArr));
    setCheckedCrowdArr(tempCheckedCrowdArr);
  };

  /**
   * 合并新旧状态
   */
  const onChange = (newData) => {
    setData({
      ...data,
      ...newData,
    });
  };

  /**
   * 点击确认
   */
  const confirm = async () => {
    // 此功能针对不同用户，权限不同，普通用户只能绘制10个节点
    // if (getAllNodes().length > 10) {
    //   if (!powerInfo) {
    //     store.set('isVipDialog', true);
    //     onCancel();
    //     return false;
    //   }
    // }
    if (checkedCrowdArr.length >= 1) {
      try {
        await Promise.all(
          checkedCrowdArr.map(async (checkedCrowdItem) => {
            // 最终校验数据是否填写完整，然后提交给全局
            try {
              await validate['name'](checkedCrowdItem.peopleName, allNodeData, currentNode, getAllNodeIds);
            } catch (e) {
                throw new Error(e);
            }
          })
        );

        // 循环所选的节点信息数组，生成节点
        if ((strategyNodeNums() + checkedCrowdArr.length) <= 150) {
          checkedCrowdArr.forEach((item, index) => {
            dragStart(nodes.sourceNodes[0], item, index);
          });
          onCancel();
        } else {
          setCrowdNodeNumDialog(true);
          return false;
        }
      } catch (e) {
        const ar = e.message.split(':');
        LzMsg.error(ar[ar.length - 1]);
      }
    } else {
      LzMsg.error('请选择人群');
    }
  };

  /**
   * 拖拽开始(模拟调用拖拽方法，并没有真正拖拽节点，这里是批量生成出来的节点)
   * @param node 被拖拽的节点
   */
  const dragStart = (node, item, index) => {
    dragStop(event, node, item, index);
  };

  /**
   * 拖拽结束事件(模拟调用拖拽方法，并没有真正拖拽节点，这里是批量生成出来的人群节点)
   */
  const dragStop = (event, node, item, index) => {
    node.info.fillComplete = true; // 所选人群必然是有id的，所以人群选择节点的fillComplete默认为true
    // 移除document上的事件绑定
    document.onmousemove = null;
    document.onmouseup = null;
    document.onmouseleave = null;
    // 将节点添加到画布中, 生成节点的id，格式是 node + 时间戳，这个有可能会更改
    const nodeId = UUID.getUUID32(); // `${node.info.name}_${Date.now()}`;
    // 在节点数据中添加节点信息，
    nodeData.push({
      nodeId,
      ...node.create(),
    });
    const batchNodeX = graph.getNodeById(currentNode.nodeId)?._cfg?.model?.x;
    const batchNodeY = graph.getNodeById(currentNode.nodeId)?._cfg?.model?.y;
    const point = graph.getClientByPoint(batchNodeX, batchNodeY); // 将渲染坐标转换为屏幕/页面坐标
    graph.addNode(
      nodeId,
      node,
      point.x + 200 * Math.ceil((index + 1) / 15),
      point.y + 120 * ((index + 1) % 15) + 40 * Math.ceil((index + 1) / 15)
    );
    try {
      // 赋值节点信息
      const createNode = nodeData.filter((node) => node.nodeId === nodeId)[0];
      createNode.data.crowdId =
        item.crowdType === 'instance' ? item.crowdId : item.strategyId;
      createNode.data.crowdName = item.name;
      createNode.data.crowdNum = item.size;
      createNode.data.crowdType =
        item.crowdType === 'instance' ? 'instance' : 'strategy';
      createNode.data.name = item.name; // 由于有些渠道生成的人群名称超过32个字，所以裁一下
      // createNode.data.crowdKeyId = item.crowdKeyId, // 所选的人群的序号id
      createNode.data.description = item.description, // 所选的人群描述
      createNode.data.peopleName = item.name, // 所选的人群名 【上面三个，是为了后续人群分析节点存个值】
      createNode.data.cycleType = 1;
      createNode.data.executeType = 1;
      createNode.data.executionTime = activityInfo.executionPlan.crowdStartTime
        ? moment(activityInfo.executionPlan.crowdStartTime).format(
          'YYYY-MM-DD HH:mm:ss'
        )
        : new Date().toLocaleDateString().replace(/\//g, '-');
      // 给节点名称赋值
      graph.updateItem(nodeId, {
        label:
          typeof item.name === 'string' && item.name !== ''
            ? item.name
            : createNode.info.label,
            fillComplete: true,
            content: createNode.data.crowdId
      });
    //   graph.updateItem(nodeId, {
    //     fillComplete: true,
    //   });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   * 点击退出
   */
  const cancel = () => {
    onCancel();
  };

  const formItemLayout = {
    labelCol: {
      span: 5,
    },
  };

  return (
    <div className={`node-menu ${styles['node-menu']}}`}>
      <Form
        className={`${styles.formDiv} ${styles.strategyDiv} canvasDialog`}
        {...formItemLayout}
      >
        <Form.Item
          hasFeedback
          label="多节点名称："
          style={{ padding: '30px 30px 0 30px' }}
        >
          <span style={{ lineHeight: '28px' }}>默认为所选择的人群名称</span>
        </Form.Item>
        <Form.Item
          label="选择人群："
          required
          requiredMessage="请选择人群"
          style={{ padding: '0 30px' }}
        >
          <Button onClick={() => setSelectCrow(true)} type="secondary">
            人群选择
          </Button>
        </Form.Item>
        <Form.Item label="" style={{ padding: '0 30px' }}>
          {checkedCrowdArr.length > 0 && (
            <div className={styles.checkedCrowds}>
              {checkedCrowdArr.map((item) => (
                <div className={styles.checkedCrowd} key={item.id}>
                  <div style={{ width: '50%' }} className={styles.crowdName}>
                    <img className={styles.crowdImg} src={crowdPng} />
                    <span>人群名称：</span>
                    <span style={{ color: '#657180' }}>{item.name}</span>
                  </div>
                  <div style={{ width: '30%', marginLeft: '20px' }}>
                    <span>人群总数：</span>
                    <span style={{ color: '#657180' }}>{item.size}</span>
                  </div>
                  <img
                    src={deletePng}
                    className={styles.deleteImg}
                    style={{ cursor: 'pointer', width: '10px', height: '10px' }}
                    onClick={() => {
                      deleteCrowd(item.id);
                    }}
                  />
                </div>
              ))}
            </div>
          )}
        </Form.Item>
        <hr />
        <div style={{ padding: '15px 30px 0 0', height: '60px' }}>
          <Button
            type="primary"
            className={`submit-btn ${styles.w88}`}
            onClick={confirm}
            style={{ float: 'right' }}
          >
            确认
          </Button>
          <Button
            type="normal"
            className={`cancel-btn ${styles.mr10} ${styles.w88}`}
            onClick={cancel}
            style={{ float: 'right' }}
          >
            取消
          </Button>
        </div>
      </Form>
      {/* 人群选择节点超过150提示弹窗 */}
      {
        crowdNodeNumDialog && <CrowdNumDialog flag={crowdNodeNumDialog} cancelHandel={()=>{
          setCrowdNodeNumDialog(false)
        }}/>
      }
      {/* 人群多选弹窗 */}
      {isSelectCrow && (
        <SelectCrowdBatch
          showDialog={isSelectCrow}
          closeDialog={() => setSelectCrow(false)}
          selectCrowd={(item) => {
            selectCrowsId(item);
          }}
          checkedCrowd={checkedCrowdArr}
          showPackageListRange="SHOWALL"
          showItem = {['1', '2', '3', '4']}
        />
      )}
    </div>
  );
};
